module.exports = __webpack_public_path__ + "static/media/headlight-red.706b9836.png";